import {init} from "../utils/_livesearch";

const settings = {
    hideClass: 'hide',
    formSelector: '[js-search-form]',
    inputSelector: '[js-search-input]',
    searchPageForm: '[js-main-search-form]',
    searchResultCount: '[js-search-count]',
    searchQuery: '[js-search-query]',
    searchTitle: '[js-search-title]',
    breadcrumbSearch: '.breadcrumb_last',
    noSearchSelector: '[js-no-search]',
    noResultSelector: '[js-search-noresult]',
    indicationSelector: '[js-search-indication]',
    iconSelector: '[js-search-icon]'
}

const forms = document.querySelectorAll(settings.formSelector);
const searchPageForm = document.querySelector(settings.searchPageForm);
const noSearch = document.querySelector(settings.noSearchSelector);
const noResult = document.querySelector(settings.noResultSelector);
const indication = document.querySelector(settings.indicationSelector);
const icon = document.querySelector(settings.iconSelector);

if (forms) {
    forms.forEach(form => {
        form.addEventListener('submit', e => {
            const input = form.querySelector(settings.inputSelector);

            if (input.value.length === 0) {
                e.preventDefault();
                return false;
            }
        })
    })
}

if (searchPageForm) {
    /**
     * Init Livesearch
     * @type {*}
     */
    const livesearch = init({
        formSelector: '[js-livesearch-search-form]',
        perPage: 4
    });

    const title = document.querySelector(settings.searchTitle);
    const searchQuery = document.querySelector(settings.searchQuery);
    const resultCounter = document.querySelector(settings.searchResultCount);
    const breadcrumb = document.querySelector(settings.breadcrumbSearch);

    if (noSearch) {
        breadcrumb.innerHTML = 'Recherche'
        noResult.style.display = 'none'
    } else {
        indication.style.display = 'none';
        icon.style.display = 'none';
    }

    livesearch.on('beforeChange', () => {
        indication.style.display = 'none';
        icon.style.display = 'none';
    });

    livesearch.on('afterChange', (response) => {
        const query = response.params.s ? response.params.s : "";
        searchQuery.innerHTML = 'Les résultats de recherche pour "' + query + '"';
        resultCounter.innerHTML = response.results.all_total;
        breadcrumb.innerHTML = "Résultats de recherche pour " + query;

        noResult.style.display = 'flex';

        if (response.results.all_total === 0) {
            title.classList.add(settings.hideClass);
            icon.style.display = 'flex';
        } else {
            icon.style.display = 'none';
            if (title.classList.contains(settings.hideClass)) {
                title.classList.remove(settings.hideClass)
            }
        }
    });
}
